import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import ProviderLayout from '../../components/ProviderLayout';
import { apiFetch } from '../../api';
import { formatDateTime } from '../../lib/datetime';
import Icon from '../../components/Icon';

function asArr(d) {
  if (Array.isArray(d)) return d;
  if (d && Array.isArray(d.items)) return d.items;
  if (d && Array.isArray(d.data)) return d.data;
  return [];
}

export default function ProviderNotificationsPage() {
  const { auth } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await apiFetch('/api/provider/notifications', auth.token);
      if (res.status === 404) {
        setItems([]); // hali bildirishnoma yo'q — bo'sh holat
        return;
      }
      if (!res.ok) throw new Error();
      setItems(asArr(await res.json().catch(() => null)));
    } catch {
      setItems([]);
      setError('Bildirishnomalarni yuklashda xatolik yuz berdi.');
    } finally {
      setLoading(false);
    }
  }, [auth.token]);

  useEffect(() => { load(); }, [load]);

  return (
    <ProviderLayout title="Bildirishnomalar">
      {loading ? (
        <div style={s.center}>Yuklanmoqda...</div>
      ) : error ? (
        <div style={s.error}>{error}</div>
      ) : items.length === 0 ? (
        <div style={s.empty}>
          <div style={s.emptyIcon}>
            <Icon name="bell" size={40} color="var(--color-primary)" />
          </div>
          <p style={s.emptyText}>Bildirishnoma yo'q</p>
          <p style={s.emptyHint}>Yangi bildirishnomalar shu yerda paydo bo'ladi.</p>
        </div>
      ) : (
        items.map((n, i) => (
          <div key={n.id ?? i} style={{ ...s.card, ...(n.read || n.isRead ? {} : s.cardUnread) }}>
            <div style={s.cardTop}>
              <span style={s.cardTitle}>{n.title || 'Bildirishnoma'}</span>
              {formatDateTime(n.createdAt) && <span style={s.date}>{formatDateTime(n.createdAt)}</span>}
            </div>
            {(n.body || n.message) && <p style={s.body}>{n.body || n.message}</p>}
          </div>
        ))
      )}
    </ProviderLayout>
  );
}

const s = {
  center: { textAlign: 'center', padding: '48px', color: 'var(--color-text-muted)' },
  error: {
    background: 'var(--color-surface)',
    border: '1px solid var(--color-danger)',
    borderRadius: 'var(--radius-input)',
    padding: '12px 14px',
    color: 'var(--color-danger)',
    fontSize: '14px',
  },
  empty: { textAlign: 'center', padding: '48px 16px' },
  emptyIcon: { display: 'flex', justifyContent: 'center', marginBottom: '10px' },
  emptyText: { margin: '0 0 4px', fontSize: '18px', fontWeight: '700', color: 'var(--color-text)' },
  emptyHint: { margin: 0, fontSize: '14px', color: 'var(--color-text-muted)' },
  card: {
    background: 'var(--color-surface-alt)',
    borderRadius: 'var(--radius-card)',
    borderLeft: '4px solid transparent',
    padding: '12px 16px',
    marginBottom: '8px',
  },
  cardUnread: { borderLeftColor: 'var(--color-primary)' },
  cardTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '8px' },
  cardTitle: { fontSize: '14px', fontWeight: '700', color: 'var(--color-text)' },
  date: { fontSize: '12px', color: 'var(--color-text-muted)', whiteSpace: 'nowrap' },
  body: { fontSize: '14px', color: 'var(--color-text)', margin: '6px 0 0', lineHeight: 1.4 },
};
